var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "CustomisedRequestCard",
    {
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "border-t-2 w-full mt-auto h-1/2" },
                [
                  _c("SuitableResources", {
                    attrs: {
                      skillIds: _vm.skillIds,
                      excludeResourceUserId: _vm.excludeResourceUserId,
                      companyId: _vm.companyId,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "border-t border-opacity-5 pt-4 flex justify-end h-1/2",
                },
                [
                  _c("CustomRequestActions", {
                    staticClass: "flex ml-auto",
                    attrs: {
                      requestId: _vm.request.id,
                      currentStatus: _vm.request.status,
                      isAdmin: _vm.isAdmin,
                      currentUserId: _vm.currentUserId,
                    },
                    on: { refetch: _vm.handleRefetch, message: _vm.message },
                    model: {
                      value: _vm.modalShown,
                      callback: function ($$v) {
                        _vm.modalShown = $$v
                      },
                      expression: "modalShown",
                    },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [
              _c("div", { staticClass: "flex w-full justify-between" }, [
                _c(
                  "div",
                  [
                    _c("RouterLink", { attrs: { to: _vm.requestLink } }, [
                      _vm._v(" " + _vm._s(_vm.requestJobTitle) + " "),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {},
                  [
                    _c("Badge", {
                      staticClass: "inline mr-8",
                      attrs: { value: _vm.status, color: _vm.badgeColor },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "w-full" }, [
        _c("div", [
          _c("div", { staticClass: "flex flex-col md:flex-row" }, [
            _c(
              "div",
              {
                staticClass:
                  "min-w-68 flex-grow xlLabelContainer mr-10 order-2 md:order-1",
              },
              [
                !_vm.createdByCurrentUser
                  ? _c(
                      "CardBodyItem",
                      { attrs: { label: "Requested by", wide: "" } },
                      [
                        _vm.requestCreatorLink
                          ? _c(
                              "RouterLink",
                              { attrs: { to: _vm.requestCreatorLink } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200 last:mr-0 mr-1",
                                  },
                                  [
                                    _vm.request.created_by.avatar
                                      ? _vm._t(
                                          "image flex-shrink-0 span-fix mt-2.5",
                                          function () {
                                            return [
                                              _c("S3Image", {
                                                class: [
                                                  _vm.defaultImageClasses,
                                                  _vm.avatarStyleClasses,
                                                ],
                                                attrs: {
                                                  s3FileKey:
                                                    _vm.request.created_by
                                                      .avatar,
                                                },
                                              }),
                                            ]
                                          },
                                          {
                                            defaultClasses: [
                                              _vm.defaultImageClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            image:
                                              _vm.request.created_by.avatar,
                                          }
                                        )
                                      : _vm._e(),
                                    !_vm.request.created_by.avatar
                                      ? _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.defaultInitialsClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            style: _vm.bgStyle,
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xs leading-none font-semibold text-white",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.request.created_by.given_name
                                                      .trimStart()[0]
                                                      .toUpperCase()
                                                  ) +
                                                    _vm._s(
                                                      _vm.request.created_by.family_name
                                                        .trimStart()[0]
                                                        .toUpperCase()
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.request.created_by.given_name
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.request.created_by.family_name
                                        ) +
                                        " "
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "text-xs font-semibold inline-block py-1 px-2 rounded-full text-blue-600 bg-blue-200 last:mr-0 mr-1",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.requestCreatorName) + " "
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "CardBodyItem",
                  { attrs: { label: "Budget / Rate", wide: "" } },
                  [
                    _vm.request.min_budget
                      ? _c("span", { staticClass: "text-xs" }, [
                          _vm._v(
                            " $ " +
                              _vm._s(_vm.request.min_budget) +
                              " - $ " +
                              _vm._s(_vm.request.max_budget) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c("CardBodyItem", { attrs: { label: "Duration", wide: "" } }, [
                  _c("span", { staticClass: "text-xs" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.transformDate(_vm.request.from_date)) +
                        " - " +
                        _vm._s(_vm.transformDate(_vm.request.to_date)) +
                        " "
                    ),
                  ]),
                ]),
                _c("CardBodyItem", { attrs: { label: "Type", wide: "" } }, [
                  _vm.request.tag
                    ? _c("span", { staticClass: "text-xs" }, [
                        _vm._v(" " + _vm._s(_vm.request.tag.name) + " "),
                      ])
                    : _vm._e(),
                ]),
                _c("CardBodyItem", { attrs: { label: "Number", wide: "" } }, [
                  _c("span", { staticClass: "text-xs" }, [
                    _vm._v(
                      " " + _vm._s(_vm.request.number_of_contractors) + " "
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "flex md:ml-auto md:order-2" }),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "w-full" },
        [
          _c(
            "CardBodyItemSkill",
            { attrs: { label: "Skills" } },
            [
              _c("ChipsWithMore", {
                attrs: { chipWithLinkDatas: _vm.requestSkills2 },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.modalShown
        ? _c("CustomRequestModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              companyId: _vm.companyId,
              customRequest: _vm.request,
              skills: _vm.skillIds,
              isAdmin: _vm.isAdmin,
            },
            on: { close: _vm.toggleRequestModal, refetch: _vm.handleRefetch },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }